import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import { BestCarsCard } from 'site-modules/new-cars-landing/components/best-cars-card/best-cars-card';

export function BestCars({ content, className = null }) {
  const contentEntries = content.children();

  return (
    <div className={classnames('best-cars', className)}>
      <h2 className="heading-3 mb-1_5">{content.title}</h2>
      <Row>
        {contentEntries &&
          contentEntries.map(item => (
            <BestCarsCard key={item.id} content={item} className="col-6 col-md-4 col-lg-3" isLazyImage />
          ))}
      </Row>
    </div>
  );
}

BestCars.propTypes = {
  content: PropTypes.shape({}).isRequired,
  className: PropTypes.string,
};
